var _clipPath, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmenitiesIconsOutdoorSpace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.11133 7.11133h17.7778v17.7778h-17.7778z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#609b32",
    r: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.0001 11.5469c-2.4553 0-4.4527 1.9978-4.4527 4.4531s1.9974 4.4531 4.4527 4.4531c2.4549 0 4.4527-1.9975 4.4527-4.4531 0-2.4557-1.9978-4.4531-4.4527-4.4531z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.0002 10.2386c-.4799 0-.8689-.38896-.8689-.86844v-1.39002c0-.47987.389-.86881.8689-.86881.4798 0 .8688.38894.8688.86881v1.39002c0 .47948-.3894.86844-.8688.86844z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.0002 21.7617c-.4799 0-.8689.389-.8689.8688v1.3897c0 .4802.389.8692.8689.8692.4798 0 .8688-.389.8688-.8692v-1.3897c0-.4798-.3894-.8688-.8688-.8688z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.074 11.9267c-.3389-.3393-.3389-.8892 0-1.2286l.983-.98296c.3389-.33894.8893-.33894 1.2286 0 .3394.33936.3394.88966 0 1.22866l-.983.9829c-.3389.3394-.8888.3394-1.2286 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.9264 20.0751c-.3393-.3397-.8893-.3397-1.2286 0l-.983.9826c-.33894.3389-.33933.8897 0 1.2286.3393.339.8897.339 1.2286 0l.983-.9834c.3393-.3389.3393-.8892 0-1.2278z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.7617 15.9997c0-.4799.389-.8688.8688-.8688h1.3901c.4798 0 .8688.3889.8688.8688 0 .4798-.389.8684-.8688.8684h-1.3901c-.4798 0-.8688-.3886-.8688-.8684z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.2386 15.9997c0-.4799-.38896-.8688-.86883-.8688h-1.38963c-.47987 0-.86881.3889-.86881.8688 0 .4798.38894.8684.86881.8684h1.39002c.47948 0 .86844-.3886.86844-.8684z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.0738 20.0745c.3394-.3389.8897-.3389 1.2287 0l.9829.983c.3394.3385.3394.8893 0 1.2282-.3393.339-.8893.339-1.2286 0l-.983-.983c-.3393-.3393-.3393-.8892 0-1.2282z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.9261 11.9266c.3393-.3393.3393-.8892 0-1.2286l-.983-.98256c-.3394-.33934-.8893-.33934-1.22864 0-.33933.33896-.33933.88926 0 1.22826l.98294.9829c.3394.3398.8893.3398 1.2287 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmenitiesIconsOutdoorSpace);
export default __webpack_public_path__ + "static/media/AmenitiesIconsOutdoorSpace.f1e0edee9913bdc9b1ef6c4f53af4558.svg";
export { ForwardRef as ReactComponent };